import React, { useEffect, useState, useRef } from 'react';
/**
 * ColumnArithmeticRenderer — Wrapper adapting ColumnArithmetic to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */
import { QuestionRendererProps } from './types';
import { ColumnArithmetic } from '../ColumnArithmetic';
import { useEdgeTriggeredSubmit } from './useEdgeTriggeredSubmit';
export function ColumnArithmeticRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [answerPayload, setAnswerPayload] = useState('');
  useEdgeTriggeredSubmit(answerPayload, shouldValidate, onAnswer, question.id);
  const handleComplete = (userAnswer: string) => {
    setAnswerPayload(userAnswer);
  };
  return <ColumnArithmetic question={question} onComplete={handleComplete} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-10465" />;
}